<template>
        <router-view/>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'App',
    methods:{
      ...mapActions(['setScrollHidden']),
      successMessage(title){
        this.$bvToast.toast(title, {
          title: `Success`,
          variant: 'success',
          solid: true
        })
      },
      errorMessage(title){
        this.$bvToast.toast(title, {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
      },
    },
    created() {
      this.$root.$on('bv::show::modal', ()=>{
        this.setScrollHidden(true)
      })
      this.$root.$on('bv::modal::hide', ()=>{
        this.setScrollHidden(false)
      })
    }
  }
</script>

<style>

.hide-scroll {
  overflow-x: hidden !important;
  overflow-y:hidden !important;
}
</style>